import { render, staticRenderFns } from "./StandardField.vue?vue&type=template&id=cfa5ba8a&scoped=true&"
import script from "./StandardField.vue?vue&type=script&lang=js&"
export * from "./StandardField.vue?vue&type=script&lang=js&"
import style0 from "./StandardField.vue?vue&type=style&index=0&id=cfa5ba8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5ba8a",
  null
  
)

export default component.exports